import { render, staticRenderFns } from "./Datetime.vue?vue&type=template&id=1b988125&scoped=true"
import script from "./Datetime.vue?vue&type=script&lang=js"
export * from "./Datetime.vue?vue&type=script&lang=js"
import style0 from "./Datetime.vue?vue&type=style&index=0&id=1b988125&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../usr/local/lib/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b988125",
  null
  
)

export default component.exports